<<!--  -->
<template>
  <div>
    <el-form :model="form" ref="form" label-width="100px" size='large' inline>
      <el-form-item label="平台">
        <el-select v-model="form.platform" class="w-200">
          <el-option
            v-for="(item,index) in plat_list"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商品标题">
        <el-input v-model.trim="form.goods_title" class="w-200"></el-input>
      </el-form-item>
      <el-form-item label="店铺名称">
        <el-input v-model.trim="form.store_nick" class="w-200"></el-input>
      </el-form-item>
      <el-form-item label="结算方式">
        <el-select v-model="form.settlement_type" class="w-200">
          <el-option
            v-for="(item,index) in settlement_type_list"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-form label-width="100px">
      <el-form-item>
        <el-button type="primary" @click="getSomelist" size='medium'>搜索</el-button>
        <el-button @click="clearSome" size='medium'>重置</el-button>
        <el-button type="primary" @click="exportList" size='medium'>导出</el-button>
      </el-form-item>
    </el-form>
    <!-- table list -->
    <!-- <el-tabs v-model="active" type="card" @tab-click="handleClick">
      <el-tab-pane :name="item.status" v-for="(item,index) in tag_list" :key="index">
        <span slot="label">{{item.name}}({{item.num}})</span>
      </el-tab-pane>
    </el-tabs> -->
    <div class='tab-box'>
      <el-button v-for='(item,index) in tag_list' :key='index'  class="page-btn-tab" :class="{ active:item.status===active}"  @click="handleClick(item.status)">
        {{item.name}}({{item.num}})
      </el-button>
    </div>
    <el-table :data="list" 
      @selection-change="handleSelectionChange" 
      ref="multipleTable" 
      :header-cell-style="{background: '#f9f9f9', color: '#333', fontSize: '14px', fontWeight: 'normal'}"
      :cell-style="{color:'#666', fontSize: '14px'}">
      <el-table-column type="selection" width="50" v-if="active==1"></el-table-column>
      <el-table-column label="店铺" width="100">
        <template slot-scope="scope">
          <div>
            <span v-if="scope.row.platform=='tianmao'">【天猫】</span>
            <span v-if="scope.row.platform=='taobao'">【淘宝】</span>
            <span v-if="scope.row.platform=='jingdong'">【京东】</span>
            <span v-if="scope.row.platform=='suning'">【苏宁】</span>
            <span v-if="scope.row.platform=='kaola'">【考拉】</span>
            <span>{{scope.row.store_nick}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="商品标题">
        <template slot-scope="scope">
          <div>{{scope.row.tb_goods_title?scope.row.tb_goods_title:scope.row.goods_title}}</div>
        </template>
      </el-table-column>
      <el-table-column label="商品链接" width="80">
        <template slot-scope="scope">
          <el-link type="primary" class="fz-14" 
            :underline="false"
            :href="scope.row.goods_out_url" 
            target="_blank">查看</el-link>
        </template>
      </el-table-column>
      <el-table-column label="合作结算方式" width="185">
        <template slot-scope="scope">
          <div>商品优惠后价格：{{Number(scope.row.real_money)}}元</div>
          <div>
            结算方式：
            <span v-if="scope.row.settlement_type==1">按实付金额结算</span>
            <span v-if="scope.row.settlement_type==2">按订单量结算</span>
          </div>
          <div>
            <span v-if="scope.row.settlement_type==1">服务费率：{{Number(scope.row.settlement_rate)}}%</span>
            <span v-if="scope.row.settlement_type==2">每单服务费：{{Number(scope.row.settlement_free)}}元</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="时间" width="210">
        <template slot-scope="scope">
          <div v-if="scope.row.order_type!=2">
            <div>优惠生效时间：</div>
            <div>{{sliceSome(scope.row.coupon_start_time)}} 至 {{sliceSome(scope.row.coupon_end_time)}}</div>
            <div>团长合作时间：</div>
            <div>{{sliceSome(scope.row.cooperative_start_time)}} 至 {{sliceSome(scope.row.cooperative_end_time)}}</div>
          </div>
          <div v-if="scope.row.order_type==2">
            <div>推广时间：{{sliceSome(scope.row.advertise_date)}}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="结算信息" width="150">
        <template slot-scope="scope">
          <div v-if="scope.row.settlement_status==7"></div>
          <div v-if="scope.row.settlement_status!=7">
            <div>订单量：{{Number(scope.row.order_num)}}</div>
            <div>付款金额：{{Number(scope.row.order_money)}}元</div>
            <div>服务费总额：{{Number(scope.row.real_payment)}}元</div>
            <div v-if="scope.row.order_type!=2">优惠券使用截图：</div>
            <div class="c-9da pointer fz-14" @click="showLunbo(scope.row.settlement_pic)">查看</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="80">
        <template slot-scope="scope">
          <div v-if="scope.row.settlement_status==7">
            待提交
            <el-tooltip
              class="item"
              effect="dark"
              content="Top Left 提示文字"
              placement="top-start"
              v-if="scope.row.admin_rejected_reason"
            >
              <div slot="content">
                驳回原因：
                <br>
                {{scope.row.admin_rejected_reason}}
              </div>
              <i class="el-icon-question tips"></i>
            </el-tooltip>
          </div>
          <!-- <div v-if="scope.row.settlement_status==3||scope.row.settlement_status==5">待审核</div> -->
          <div v-if="scope.row.settlement_status==1" class="flex-al">
            待支付
            <el-tooltip
              class="item"
              effect="dark"
              content="Top Left 提示文字"
              placement="top-start"
              v-if="scope.row.pay_rejected_reason"
            >
              <div slot="content">
                驳回原因：
                <br>
                {{scope.row.pay_rejected_reason}}
              </div>
              <i class="el-icon-question tips"></i>
            </el-tooltip>
          </div>
          <div v-if="scope.row.settlement_status==2">
            <div>支付成功</div>
            <div>完成时间：{{scope.row.pay_time}}</div>
          </div>
          <div v-if="scope.row.settlement_status==6">
            <div>交易关闭</div>
            <div>关闭时间：{{scope.row.shutdown_time}}</div>
          </div>

          <div v-if="scope.row.settlement_status==11||scope.row.settlement_status==9">
            <div>已支付待审核</div>
          </div>

          <div v-if="scope.row.settlement_status==3||scope.row.settlement_status==10||scope.row.settlement_status==5">
            <div>待审核</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="110">
        <template slot-scope="scope">
          <el-button
            class="fz-14"
            type="text"
            @click="showUp(scope.row)"
            v-if="scope.row.settlement_status==7||scope.row.settlement_status==8"
          >上传结算信息</el-button>
          <el-button
            type="text"
            class="mt-10 w-104 ml-0 fz-14"
            v-if="scope.row.settlement_status==1"
            @click="goPayorder(scope.row,1)"
          >支付</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 页码 -->
    <pagePagination :pageData="pageData" @pageChange="pageChange"></pagePagination>

    <el-dialog width="640px" title :visible.sync="innerVisible" :close-on-click-modal="false">
      <el-carousel height="540px">
        <el-carousel-item v-for="item in example" :key="item" :autoplay="false" style="width:600px">
          <img :src="item" style="width:600px;height:100%;">
        </el-carousel-item>
      </el-carousel>
    </el-dialog>

    <!-- <el-dialog
      width="520px"
      title="提示"
      :visible.sync="hebing.hebing"
      :close-on-click-modal="false"
      @before-close="closeHebing"
      :show-close='false'
    >
      <div>
        您已选择合并支付，共支付
        <span class="c-9da">{{hebing.mtstorids.length}}</span>条订单，合计
        <span class="c-9da">{{hebing.count_money}}</span>元
      </div>
      <span slot="footer">
        <el-button @click="closeHebing">取消</el-button>
        <el-button type="primary" @click="morePay">确认支付</el-button>
      </span>
    </el-dialog>-->
    <!-- //支付方式选择 -->
    <el-dialog
      width="520px"
      title="支付"
      :visible.sync="zhifu.zhifu"
      :close-on-click-modal="false"
      @before-close="closeZhifu"
      :show-close="false">
      <div>
        您已选择
        <span>{{zhifu.count}}</span>条订单，合计
        <span>{{zhifu.heji}}</span>元
      </div>
      <div class>
        <el-radio v-model="zhifu.type" label="1" class="blcok line-40">线上支付</el-radio>
        <el-radio v-model="zhifu.type" label="2" class="block line-40">支付宝转账、上传付款截图。</el-radio>
        <el-radio v-model="zhifu.type" label="3" class="block line-40">银行转账、上传付款截图。</el-radio>
      </div>
      <span slot="footer">
        <el-button @click="closeZhifu">取消</el-button>
        <el-button type="primary" @click="checkZhifu">确认</el-button>
      </span>
    </el-dialog>
    <!-- 上传付款截图 -->
    <el-dialog
      width="520px"
      :title="zhifu.title"
      :visible.sync="zhifu.up"
      :close-on-click-modal="false"
      @before-close="closeZhifuup"
      :show-close="false">
      <!-- <div> -->
      <el-form ref="form" :model="zhifu.form" label-width="140px">
        <el-form-item label="付款日期" :required="true">
          <el-date-picker
            class="w-280"
            v-model="zhifu.form.pay_time"
            type="date"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择付款截图上的打款日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="支付宝交易号" :required="true" v-if="zhifu.type==2">
          <el-input
            v-model="zhifu.form.alipay_trade_no"
            type="number"
            class="kucun w-280"
            @mousewheel.native.prevent
          ></el-input>
          <div>即付款截图中的“订单号”，示例</div>
          <div>2019082022001466230507380196</div>
        </el-form-item>
        <el-form-item label="付款截图:" :required="true">
          <Upsome :file_list="zhifu.file_list" :type="1" :limits="zhifu.limits" @getPic="getPic"></Upsome>
        </el-form-item>
      </el-form>
      <!-- <div class='mb-10'>付款截图:</div>
      <Upsome :file_list="zhifu.file_list" :type="1" :limits="zhifu.limits" @getPic="getPic"></Upsome>-->
      <!-- </div> -->
      <span slot="footer">
        <el-button @click="closeZhifuup">取消</el-button>
        <el-button type="primary" @click="savePayPic">确认</el-button>
      </span>
    </el-dialog>
    <!-- 上传结算信息 -->
    <Upfile v-if="up" @getUp="getUp" :set_list="set_list"></Upfile>
    <div class="all-check" v-if="pageData.count&&active==1">
      <div class="all-checks">
        <div>
          <el-button type="primary" plain @click="toggleSelection(list)">全选</el-button>
          <el-button @click="toggleSelection()">取消</el-button>
        </div>
        <div class="all-r">
          <div class="mr-10">您已选择合并支付，共支付 {{hebing.length}}条订单，合计 {{hebing.heji}}元</div>
          <el-button
            type="primary"
            :disabled="hebing.mtstorids.length!=0?false:true"
            @click="getMoreToPay(2)"
          >合并支付</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./tool.css";
import Upfile from "./upfile";
import utils from "../../config/api.js";
import util from "../../utils/util";
import Upsome from "../template/upsome.vue";
import sensors from "sa-sdk-javascript";
import pagePagination from "@/components/page_pagination.vue"
export default {
  name: "transaction",
  data() {
    return {
      api: {
        orderList: "home/Merchant/orderList", //获取结算订单列表
        orderStatus: "home/Merchant/orderStatus", //是否有tips
        pay: "home/Merchant/pay",
        getMoreToPay: "home/Merchant/getMoreToPay", //合并支付检查
        morePay: "home/Merchant/morePay", //进行合并支付
        savePayPic: "home/Merchant/savePayPic" //上传支付凭证
      },
      pageData: {
        count: 0,
        page: 1,
        offset: 20
      },
      form: {
        platform: "", //所在商城
        goods_title: "", //商品名称
        store_nick: "", //店铺名称
        settlement_type: "", //结算方式
        settlement_status: "" //状态
      },
      innerVisible: false, //查看的轮播弹框
      example: [], //轮播图的内容
      active:"", //列表表头的状态默认为全部
      set_list: "", //传给子组件的数据

      up: false, //是否进行上传

      list: [
        //列表
        {
          name: "小米手机"
        }
      ],
      plat_list: [
        {
          label: "淘宝",
          value: "taobao"
        },
        {
          label: "天猫",
          value: "tianmao"
        },
        {
          label: "京东",
          value: "jingdong"
        },
        {
          label: "苏宁",
          value: "suning"
        },
        {
          label: "考拉",
          value: "kaola"
        }
      ],
      settlement_type_list: [
        {
          label: "实付金额结算",
          value: 1
        },
        {
          label: "订单量结算",
          value: 2
        }
      ],
      tag_list: [
        {
          name: "待提交订单",
          num: 0,
          status: "7"
        },
        {
          name: "待审核订单",
          num: 0,
          status: "3"
        },
        {
          name: "待支付订单",
          num: 0,
          status: "1"
        },
        {
          name: "支付成功订单",
          num: 0,
          status: "2"
        },
        {
          name: "全部订单",
          num: 0,
          status: ""
        }
      ],
      hebing: {
        //合并支付
        mtstorids: [], //合并支付的id
        hebing: false, //合并支付弹框
        count_money: "", //支付总需
        length: 0, //条数
        heji: 0 //合计
      },
      zhifu: {
        //支付方式选择
        zhifu: false,
        type: 0,
        up: false,
        file_list: [],
        limits: 2,
        data: {}, //单条支付信息
        conut: 0, //选择支付条数
        heji: "", //需要支付价格
        num: "", //单项支付打开弹框还是合并支付打开弹框
        title: "", //上传截图的title
        form: {
          pay_time: "", //付款时间
          alipay_trade_no: "" //支付宝交易账号
        }, //form
        pay_pic: "" //支付凭证
      }
    };
  },
  components: {
    pagePagination,
    Upfile: Upfile,
    Upsome: Upsome
  },
  created() {
    this.orderList();
    this.orderStatus();
    this.sensorsInit()
  },
  mounted() {},
  methods: {
    getSomelist() {
      //搜索
      this.pageData.page = 1;
      this.orderList();
    },
    orderList() {
      //获取结算订单列表
      let _this = this;
      let data = this.form;
      data.page = this.pageData.page;
      data.offset = this.pageData.offset;
      this.$http({
        method: "GET",
        url: _this.api.orderList,
        params: data
      }).then(res => {
        if (res.code == 1) {
          _this.list = res.data.list;
          _this.setTtile(res.data.count);
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    showLunbo(data) {
      //轮播图的查看
      if (!data) {
        return false;
      } else {
        this.example = data.split(",");
        this.innerVisible = true;
      }
    },
    setTtile(data) {
      //设置表头
      let list = this.tag_list;
      this.pageData.count = data.count;
      for (let i = 0; i < list.length; i++) {
        if (list[i].status == 7) {
          this.tag_list[i].num = data.wait_settlement;
        } else if (list[i].status == 3) {
          this.tag_list[i].num = data.wait_check;
        } else if (list[i].status == 1) {
          this.tag_list[i].num = data.wait_pay;
        } else if (list[i].status == 2) {
          this.tag_list[i].num = data.pay_sucess;
        } else if (list[i].status =='') {
          this.tag_list[i].num = data.total;
        }
      }
      if (
        data.wait_check == 0 &&
        data.wait_pay == 0 &&
        data.wait_settlement == 0
      ) {
        //去掉tip
        this.orderStatus();
      }
    },
    showUp(data) {
      this.set_list = data;
      this.up = true;
    },
    getUp(data) {
      //获得子组件的值1不刷新 2刷新页面
      if (data == 1) {
        this.up = false;
      } else if (data == 2) {
        this.up = false;
        this.orderList();
      }
    },
    handleClick(status) {
      this.active=status;
      //切换状态handleSizeChange
      this.$forceUpdate();
      this.pageData.page = 1;
      this.form.settlement_status = status;
      this.orderList();
    },
    // 分页改变
    pageChange(page, pageSize){
      this.pageData.page = page;
      this.pageData.offset = pageSize;
      this.orderList()
    },
    clearSome() {
      this.pageData.page = 1;
      this.pageData.offset = 10;
      this.form.platform = "";
      this.form.goods_title = "";
      this.form.store_nick = "";
      this.form.settlement_type = "";
    },
    exportList() {
      //导出
      let _this = this;
      let url =
        utils.api +
        this.api.orderList +
        "?goods_title=" +
        this.form.goods_title +
        "&platform=" +
        this.form.platform +
        "&store_nick=" +
        this.form.store_nick +
        "&settlement_status=" +
        this.form.settlement_status +
        "&settlement_type=" +
        this.form.settlement_type +
        "&export=1" +
        "&auth_token=" +
        this.$http.getAuth("auth_token");
      window.open(url);
    },
    orderStatus() {
      let _this = this;
      let data = {};
      this.$http({
        method: "GET",
        url: _this.api.orderStatus,
        params: data
      }).then(res => {
        if (res.code == 1) {
          if (res.data.count <= 0) {
            this.$store.dispatch("setTips", 3);
          }
        } else {
          console.log(res.msg);
        }
      });
    },
    goPayorder(datas, num) {
      //直接去支付
      this.zhifu.data = datas;
      this.zhifu.count = 1;
      this.zhifu.heji = datas.real_payment;
      this.zhifu.zhifu = true;
      this.zhifu.num = num;
    },
    onePayorder() {
      //单次支付
      let _this = this;
      let data = {
        mtstorid: this.zhifu.data.mtstorid
      };
      this.$http({
        method: "GET",
        url: _this.api.pay,
        params: data
      }).then(res => {
        if (res.code == 1) {
          window.open(res.data);
        } else {
          _this.$message.error(res.msg);
        }
      });
    },
    sliceSome(data) {
      if (data) {
        return data.slice(0, 10);
      }
    },
    handleSelectionChange(val) {
      console.log(val)
      //全选和全不选
      if (val.length != 0) {
        this.hebing.mtstorids = [];
        let str = 0;
        for (let i = 0; i < val.length; i++) {
          this.hebing.mtstorids.push(val[i].mtstorid);
          str += Number(val[i].real_payment);
        }
        this.hebing.length = val.length;
        this.hebing.heji = str.toFixed(2);
      } else {
        this.hebing.mtstorids = [];
        this.hebing.length = 0;
        this.hebing.heji = 0;
      }
    },
    toggleSelection(rows) {
      console.log(rows)
      //取消全选
      if (rows) {
        this.toggleSelection();
        // this.$refs.multipleTable.clearSelection();
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    closeHebing() {
      //关闭弹框
      this.hebing.hebing = false;
    },
    getMoreToPay(num) {
      //检查合并支付
      let _this = this;
      let data = {
        mtstorids: this.hebing.mtstorids.join(",")
      };
      this.$http({
        method: "GET",
        url: _this.api.getMoreToPay,
        params: data
      }).then(res => {
        if (res.code == 1) {
          _this.hebing.count_money = res.data.count_money;
          _this.zhifu.zhifu = true;
          _this.zhifu.count = this.hebing.length;
          _this.zhifu.heji = this.hebing.heji;
          _this.zhifu.num = num;
          // _this.hebing.hebing = true;
        } else {
          _this.$message.error(res.msg);
        }
      });
    },

    morePay() {
      //确认合并支付
      let _this = this;
      this.$http({
        method: "POST",
        url: _this.api.morePay,
        data: {
          mtstorids: _this.hebing.mtstorids.join(",")
        }
      }).then(res => {
        if (res.code == 1) {
          window.open(res.data);
        } else {
          _this.$message.error(res.msg);
        }
      });
    },
    closeZhifu() {
      //关闭支付
      this.zhifu.zhifu = false;
      this.zhifu.type = "";
    },
    checkZhifu() {
      //选择支付方式
      if (!this.zhifu.type) {
        this.$message.warning("请选择支付方式");
        return false;
      }
      if (this.zhifu.type == 1) {
        //直接唤起支付
        if (this.zhifu.num == 1) {
          this.onePayorder(); //单次支付
        } else if (this.zhifu.num == 2) {
          this.morePay();
        }
      } else if (this.zhifu.type == 2 || this.zhifu.type == 3) {
        //上传截图
        this.zhifu.up = true;
        if (this.zhifu.type == 2) {
          this.zhifu.title = "支付宝转账上传付款截图";
        } else if (this.zhifu.type == 3) {
          this.zhifu.title = "银行转账上传付款截图";
        }
      }
    },
    closeZhifuup() {
      //截图弹框
      this.zhifu.up = false;
      this.zhifu.file_list = [];
      this.zhifu.pay_pic = "";
      this.zhifu.form = {
        pay_time: "", //付款时间
        alipay_trade_no: "" //支付宝交易账号
      };
    },
    getPic(data) {
      //获取上传的图片
      this.zhifu.pay_pic = data;
    },
    savePayPic() {
      //上传支付凭证
      let _this = this;
      if (!this.zhifu.form.pay_time) {
        this.$message.warning("请填写付款日期");
        return false;
      } else if (!this.zhifu.form.alipay_trade_no && this.zhifu.type == 2) {
        this.$message.warning("请填写支付宝交易号");
        return false;
      } else if (!this.zhifu.pay_pic.length) {
        this.$message.warning("请上传付款截图");
        return false;
      }
      // console.log(this.zhifu.data)
      let data = {
        mtstorids:
          this.zhifu.num == 1
            ? _this.zhifu.data.mtstorid
            : _this.hebing.mtstorids.join(","), //结算id
        pay_pic: _this.zhifu.pay_pic,
        alipay_trade_no: _this.zhifu.form.alipay_trade_no,
        type: _this.zhifu.type,
        pay_time: _this.zhifu.form.pay_time
      };
      this.$http({
        method: "POST",
        url: _this.api.savePayPic,
        data: {
          mtstorids:
            this.zhifu.num == 1
              ? _this.zhifu.data.mtstorid
              : _this.hebing.mtstorids.join(","), //结算id
          pay_pic: _this.zhifu.pay_pic,
          alipay_trade_no: _this.zhifu.form.alipay_trade_no,
          type: _this.zhifu.type,
          pay_time: _this.zhifu.form.pay_time
        }
      }).then(res => {
        if (res.code == 1) {
          _this.zhifu.zhifu = false;
          _this.zhifu.type = 0;
          _this.$message.success(res.msg);
          _this.closeZhifuup();
          _this.orderList();
        } else {
          _this.$message.error(res.msg);
        }
      });
    },
    // 神策
    sensorsInit(){
      let that = this
      sensors.init({
        server_url: 'https://shence-import.smzdm.com/sa?project=datasystem_default',//测试
		    // server_url: 'https://shence-import.smzdm.com/sa?project=linkstar_project',//线上
      });
      let user_info = that.$http.getAuth('user_info');   
      if(user_info && user_info.urid){
        sensors.login(user_info.urid)
      }
      sensors.track('LabelClick', {
        pid: '星罗好货',
        platform_type: 'PC',
        is_login: true,
        label_name: '商家交易管理',
        page_type: '个人中心',
      });
    },
  }
};
</script>
<style  scoped>
.w-104 {
  width: 104px;
}
.ml-0 {
  margin-left: 0px;
}
.mr-10 {
  margin-right: 10px;
}
.mb-60 {
  margin-bottom: 60px;
}
.all-check {
  position: fixed;
  width: 1000px;
  height: 60px;
  box-shadow: 0 2px 11px 0 rgba(215, 215, 215, 0.5);
  background: #fff;
  bottom: 0;
  z-index: 100;
}
.all-checks {
  display: flex;
  height: 60px;
  padding: 0 20px;
  justify-content: space-between;
  align-items: center;
}
.c-9da {
  color: #6435E8;
}
.all-r {
  display: flex;
  font-size: 12px;
  align-items: center;
}
.block {
  display: block;
}
.line-40 {
  line-height: 40px;
}
.zhifu-type {
  line-height: 48px;
}
.mb-10 {
  margin-bottom: 10px;
}
.tips {
  font-size: 20px;
  color: #6435E8;
  /* right:-13px;
  top:4px; */
}
.flex-al {
  display: flex;
  align-items: center;
}
.w-280 {
  width: 280px;
}
.tab-box{
  border-top:1px solid #f4f4f4;
  display: flex;
  padding:20px 0;
}
</style>